import MccAirlineIcon from 'ext-ui/svg/icon/MccAirlineIcon'
import MccAssociationsIcon from 'ext-ui/svg/icon/MccAssociationsIcon'
import MccAutomobilesIcon from 'ext-ui/svg/icon/MccAutomobilesIcon'
import MccBusinessIcon from 'ext-ui/svg/icon/MccBusinessIcon'
import MccCarRentalIcon from 'ext-ui/svg/icon/MccCarRentalIcon'
import MccEducationIcon from 'ext-ui/svg/icon/MccEducationIcon'
import MccEntertainmentIcon from 'ext-ui/svg/icon/MccEntertainmentIcon'
import MccFinancialIcon from 'ext-ui/svg/icon/MccFinancialIcon'
import MccGasIcon from 'ext-ui/svg/icon/MccGasIcon'
import MccGovernmentIcon from 'ext-ui/svg/icon/MccGovernmentIcon'
import MccLodgingIcon from 'ext-ui/svg/icon/MccLodgingIcon'
import MccMailPhoneOrderIcon from 'ext-ui/svg/icon/MccMailPhoneOrderIcon'
import MccOtherIcon from 'ext-ui/svg/icon/MccOtherIcon'
import MccPersonalIcon from 'ext-ui/svg/icon/MccPersonalIcon'
import MccProfessionalIcon from 'ext-ui/svg/icon/MccProfessionalIcon'
import MccRepairIcon from 'ext-ui/svg/icon/MccRepairIcon'
import MccRestaurantsIcon from 'ext-ui/svg/icon/MccRestaurantsIcon'
import MccRetailIcon from 'ext-ui/svg/icon/MccRetailIcon'
import MccTelecomIcon from 'ext-ui/svg/icon/MccTelecomIcon'
import MccTransportationIcon from 'ext-ui/svg/icon/MccTransportationIcon'
import MccUtilitiesIcon from 'ext-ui/svg/icon/MccUtilitiesIcon'
import MccWholesaleIcon from 'ext-ui/svg/icon/MccWholesaleIcon'
import React, { ComponentProps } from 'react'
import { MccGroupKey } from 'src/models/transaction.models'

export const mccIconMapping: Record<
  MccGroupKey,
  React.FC<
    {
      className?: string
    } & ComponentProps<'svg'>
  >
> = {
  AIRLINE: MccAirlineIcon,
  ENTERTAINMENT: MccEntertainmentIcon,
  ASSOCIATIONS: MccAssociationsIcon,
  AUTOMOBILES: MccAutomobilesIcon,
  BUSINESS: MccBusinessIcon,
  CAR_RENTAL: MccCarRentalIcon,
  EDUCATION: MccEducationIcon,
  FINANCIAL: MccFinancialIcon,
  GAS: MccGasIcon,
  GOVERNMENT: MccGovernmentIcon,
  LODGING: MccLodgingIcon,
  MAIL_PHONE_ORDER: MccMailPhoneOrderIcon,
  PERSONAL: MccPersonalIcon,
  PROFESSIONAL: MccProfessionalIcon,
  REPAIR: MccRepairIcon,
  RESTAURANTS: MccRestaurantsIcon,
  RETAIL: MccRetailIcon,
  TELECOM: MccTelecomIcon,
  TRANSPORTATION: MccTransportationIcon,
  UTILITIES: MccUtilitiesIcon,
  WHOLESALE: MccWholesaleIcon,
  OTHER: MccOtherIcon,
} as const

export const getMccIcon = (mccGroupKey: MccGroupKey) => {
  return mccIconMapping[mccGroupKey] || MccOtherIcon
}
